exelare_jobs.define('main_candidate',[], function () {
    return function ($, ko, root) {
        $.get(root.ExelareSettings.mapPathOf("directApplicationFormTemplate"), function (html) {
            root.container.html('');

            root.container.append(html);

            var formView = $('#appForm');
            var appFormMdl = new root.AppFormModel(null);

            appFormMdl.initializeValidator();
            ko.applyBindings(appFormMdl, formView[0]);
            $('#exelare_jobs_container .input-group.date').datepicker({});
        });
    }
 });
